import * as projectPhases from "./projectPhases";
import i18n from "@/common/lang.serivce";

const ProjectPhases = {
  list() {
    return Object.keys(projectPhases);
  },
  getAll() {
    return this.list().map(projectPhase => {
      return {
        value: projectPhase,
        text: i18n.t("projectPhases." + projectPhase)
      };
    });
  }
};

export default ProjectPhases;
